import { render } from "./BlankTitle.vue?vue&type=template&id=64aec7dd"
import script from "./BlankTitle.vue?vue&type=script&lang=js"
export * from "./BlankTitle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "64aec7dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64aec7dd', script)) {
    api.reload('64aec7dd', script)
  }
  
  module.hot.accept("./BlankTitle.vue?vue&type=template&id=64aec7dd", () => {
    api.rerender('64aec7dd', render)
  })

}

script.__file = "src/views/misc/BlankTitle.vue"

export default script